<template>
    <NuxtLink 
      :id="productId"
      :to="$localePath({ name: 'product-slug', params: { slug: product.slug } })" 
      external
      :class="[
        'flex items-center gap-4 p-2 transition-all duration-200',
        'focus:outline-none focus:ring-2 focus:ring-primary-500', 
        active ? 'bg-primary-50 dark:bg-primary-900/20 ring-2 ring-primary-500' : ''
      ]"
    >   
        <img v-if="product.images.length" :src="product.images[0]!.url" :alt="product.name" class="w-16 h-16 object-cover rounded" />
        <img v-else src="/img/placeholder.jpg" :alt="product.name" class="w-16 h-16 object-cover rounded" />

        <div class="flex flex-col">
            <h3 class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ product.name }}</h3>
            <PriceCompare :price="product.price" :oldPrice="product.regularPrice" class="text-sm" />
        </div>
    </NuxtLink>        
</template>
<script setup lang="ts">
import type { ListProduct, Product } from '~/types'
import PriceCompare from '~/components/molecules/PriceCompare.vue'

defineProps<{
    product: ListProduct | Product
    active?: boolean
    productId?: string
}>()
</script>